// Window predicates for the MLAP delta-band period cache. They MUST mirror the backend's
// interval semantics exactly, otherwise locally-filtered (narrowed) windows would differ
// from server-loaded ones:
// - Schedule Activities: FULLY-INSIDE — earlyStartDate >= start AND earlyFinishDate <= finish
//   (see findLookAheadIdsByScenarioIdsAndInterval).
// - Resource Tasks: OVERLAP on bounds — start BETWEEN window OR finish BETWEEN window, where
//   the backend expands the window to [startT00:00:00, finishT23:59:59]
//   (see DateDTO.getStartDateTime/getFinishDateTime).
// All comparisons are lexical on ISO strings ("YYYY-MM-DD" / "YYYY-MM-DDTHH:mm:ss"), which
// orders correctly and avoids timezone drift from Date parsing.

export const saRowInWindow = (row, win) => {
  if (!win) return true;
  const s = row?.scheduleActivity?.earlyStartDate;
  const f = row?.scheduleActivity?.earlyFinishDate;
  return (
    s != null && f != null && String(s) >= win.start && String(f) <= win.finish
  );
};

const inDateTimeWindow = (value, win) => {
  if (value == null) return false;
  const v = String(value);
  return v >= `${win.start}T00:00:00` && v <= `${win.finish}T23:59:59`;
};

export const rtRowInWindow = (row, win) => {
  if (!win) return true;
  const rt = row?.resourceTask;
  if (!rt) return false;
  return inDateTimeWindow(rt.start, win) || inDateTimeWindow(rt.finish, win);
};

// Coverage math shared by both delta thunks. Windows/coverages are {start, finish} of
// "YYYY-MM-DD" strings.
export const windowInsideCoverage = (win, cov) =>
  win.start >= cov.start && win.finish <= cov.finish;

export const windowsOverlap = (win, cov) =>
  win.start <= cov.finish && win.finish >= cov.start;

// The missing band(s) to fetch when widening `cov` to include `win`.
export const missingBands = (win, cov) => {
  const bands = [];
  if (win.start < cov.start) bands.push({ start: win.start, finish: cov.start });
  if (win.finish > cov.finish)
    bands.push({ start: cov.finish, finish: win.finish });
  return bands;
};

export const mergeCoverage = (win, cov) => ({
  start: win.start < cov.start ? win.start : cov.start,
  finish: win.finish > cov.finish ? win.finish : cov.finish,
});
